import styled from 'styled-components'

export const Container = styled.div`
  padding-top: 3rem;
  width: 100%; /* Largeur du conteneur */
  max-width: 600px; /* Limite la largeur maximale à 400px */
  height: 400px; /* Hauteur fixe */
  margin: 0 auto; /* Centre le conteneur horizontalement */
  text-align: center;
  position: relative;
  overflow: hidden; /* Cache tout ce qui dépasse du conteneur */
`

export const StyledMedia = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  img,
  video {
    width: 100%; /* S'adapte à la largeur du conteneur */
    height: 100%; /* S'adapte à la hauteur du conteneur */
    object-fit: contain; /* Remplit le conteneur tout en coupant si nécessaire */
  }

  .video-js {
    width: 100% !important; /* Forcer la largeur */
    height: 100% !important; /* Forcer la hauteur */
    max-width: 600px;
    max-height: 400px;
  }
`
